import { toast } from "react-toastify";

const defaultErrorHandler = (error, type, asNotifications = true) => {
    let errorMessages = [];
    
    // Log full error for debugging
    console.error("API Error:", {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message
    });
    
    if (error.response && error.response.data && error.response.data.errors) {
        if (typeof error.response.data.errors === "string") {
            errorMessages.push(error.response.data.errors);
        } else if (Array.isArray(error.response.data.errors)) {
            errorMessages = error.response.data.errors;
        } else if (typeof error.response.data.errors === "object") {
            Object.keys(error.response.data.errors).forEach(key => {
                if (Array.isArray(error.response.data.errors[key])) {
                    error.response.data.errors[key].forEach(perError => {
                        errorMessages.push(perError);
                    });
                } else {
                    errorMessages.push(error.response.data.errors[key]);
                }
            });
        } else if (typeof error.response.data === "object") {
            Object.keys(error.response.data).map(key =>
                errorMessages.push(error.response.data[key]));
        }
    } else if (error.response && error.response.data && error.response.data.errorMessage) {
        errorMessages.push(error.response.data.errorMessage);
    } else if (error.response && error.response.data && error.response.data.title) {
        // Handle ASP.NET Core ProblemDetails format
        let detailMessage = error.response.data.title;
        if (error.response.data.detail) {
            detailMessage += `: ${error.response.data.detail}`;
        }
        errorMessages.push(detailMessage);
    } else if (error.response && error.response.data && typeof error.response.data === "string") {
        errorMessages.push(error.response.data);
    } else if (error.response && error.response.data && typeof error.response.data === "object") {
        // Try to extract any meaningful message from the response object
        const data = error.response.data;
        if (data.message) {
            errorMessages.push(data.message);
        } else if (data.Message) {
            errorMessages.push(data.Message);
        } else if (data.error) {
            errorMessages.push(typeof data.error === "string" ? data.error : JSON.stringify(data.error));
        } else {
            // Last resort: show stringified response data
            errorMessages.push(`Error ${error.response.status}: ${JSON.stringify(data)}`);
        }
    } else if (error.message && typeof error.message === "string") {
        errorMessages.push(error.message);
    }

    if (asNotifications) {
        errorMessages.forEach((message) => {
            if (typeof message === "string") {
                toast(message, {
                    type: toast.TYPE.ERROR,
                    autoClose: false
                });
            }
        });
        return {
            type,
            payload: []
        };
    }

    return {
        type,
        payload: errorMessages
    };
};

export default defaultErrorHandler;
